import { VContent } from 'vuetify/lib/components/VContent';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WebsiteHeader'),_c(VContent,[_vm._t("default")],2),_c('WebsiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }